export enum DrawerPosition {
  left = 'left',
  right = 'right',
  top = 'top',
}
export interface DrawerProps {
  onClose: () => void
  isOpen: boolean
  children?: React.ReactNode
  topPosition?: string | number
  position?: DrawerPosition
}
